import { Box, Tooltip, Typography } from '@mui/material'
import { ActionsBreakdown } from '../../domain/permission/computeActionsBreakdown'

const cellContainerSx = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
} as const

export const NoneText = () => (
  <Typography variant="body2" sx={{ lineHeight: 1.3, py: 0.5, color: 'text.disabled', fontStyle: 'italic' }}>
    none
  </Typography>
)

export const StringListCell = ({ value }: { value: string[] | undefined }) => {
  if (!value || value.length === 0) return <NoneText />
  const text = value.join(', ')
  return (
    <Tooltip title={text} placement="top-start">
      <Box sx={cellContainerSx}>
        <Typography variant="body2" noWrap sx={{ lineHeight: 1.3 }}>
          {text}
        </Typography>
      </Box>
    </Tooltip>
  )
}

export const TypesPermissionsCell = ({ value }: { value: ActionsBreakdown['perType'] | undefined }) => {
  if (!value || value.length === 0) return <NoneText />
  const lines = value.map((entry) => `${entry.typeName}: ${entry.labels.join(', ')}`)
  return (
    <Tooltip
      title={
        <Box component="div" sx={{ whiteSpace: 'pre-line' }}>
          {lines.join('\n')}
        </Box>
      }
      placement="top-start"
    >
      <Box sx={cellContainerSx}>
        <Typography variant="body2" noWrap sx={{ lineHeight: 1.3 }}>
          {value.map((entry, idx) => (
            <Box key={entry.typeName} component="span">
              {idx > 0 ? ' · ' : ''}
              <Box component="span" sx={{ fontWeight: 600 }}>
                {entry.typeName}:
              </Box>{' '}
              {entry.labels.join(', ')}
            </Box>
          ))}
        </Typography>
      </Box>
    </Tooltip>
  )
}
